import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { downgradeComponent } from "@angular/upgrade/static";
import * as angular from "angular";

import { SimuladorFreteRoutingModule } from "./simulador-frete.routes";
import { ServicesModule } from "../services/services.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  MatFormFieldModule,
  MatInputModule,
  MatButtonModule,
  MatIconModule,
} from "@angular/material";
import { NgxMaskModule } from "ngx-mask";
import { CurrencyMaskModule } from "ng2-currency-mask";
import {
  CurrencyMaskConfig,
  CURRENCY_MASK_CONFIG,
} from "ng2-currency-mask/src/currency-mask.config";
import { SimuladorFreteComponent } from "./pages/simulador/simulador-frete.component";
import { SimuladorFreteProdutoComponent } from "./components/produto/produto.component";
import { SimuladorFreteService } from "./services/simulador-frete.service";

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "left",
  allowNegative: true,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: ".",
};

@NgModule({
  declarations: [SimuladorFreteComponent, SimuladorFreteProdutoComponent],
  imports: [
    CommonModule,
    SimuladorFreteRoutingModule,
    ServicesModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    CurrencyMaskModule,
    NgxMaskModule.forRoot(),
  ],
  providers: [
    {
      provide: CURRENCY_MASK_CONFIG,
      useValue: CustomCurrencyMaskConfig,
    },
    SimuladorFreteService,
  ],
  entryComponents: [SimuladorFreteComponent, SimuladorFreteProdutoComponent],
  exports: [SimuladorFreteComponent, SimuladorFreteProdutoComponent],
})
export class SimuladorFreteModule {}

try {
  angular
    .module("mandaeApp")
    .directive(
      "appSimuladorFrete",
      downgradeComponent({ component: SimuladorFreteComponent })
    );
} catch (e) {}
